import React from 'react';
import { SessionTimeoutDialog } from './components/SessionTimeoutDialog';
import { useInteractiveSession } from './hooks/useInteractiveSession';

export const SessionTimeout = (): JSX.Element => {
  const {
    isExpiring,
    extending,
    secondsRemaining,
    logout,
    extend
  } = useInteractiveSession();

  if (!isExpiring || extending) return <></>;

  return (
    <SessionTimeoutDialog
      open={isExpiring}
      secondsRemaining={secondsRemaining}
      onLogout={logout}
      onContinue={extend}
    />
  );
};
